<template>
<div>
	<div>
		<!-- <div class="mt2x">
			<div class="tableSys mb05x vaM_E mb2x">
				<div class="w6x taR cSub pr1x">{{$t('word1532',['产品'])}}</div>
				<div>
					<Select :list="proList" :size="'m'" class="w100pct" :bindActive="proActive.active" :keyMap="{text:'name',value:'id'}" @Click="ProSelect"></Select>
				</div>
				<div class="w7x"></div>
			</div>
		</div> -->
		<transition-group tag="div" class="enableList mt05x bdSub boxR-light cb tra ml05x_E pb05x mt05x_E fL_E w60pct" :class="{pr3x:snList.length>0,pr1x:snList.length==0}" v-on:leave="el=>{transitionAction(el,'hide-x');}" :duration="500">
			<button v-if="snList.length>0" class="clearTag hover-f-error hover-effect-rotate tra-fast" :key="'clear'" @click="clear" type="button"><div class="icoSys w1x h1x bgSub fSub fs16x"><Icon name="no" /></div></button>
			<TagBox v-for="(account,index) in snList" :key="account.sn" :styleType="'tag'" :val="account.sn" :data="account" @Remove="onRemove(account.sn,index)" ></TagBox>
			<button :key="'add'" class="lh15 cMain" type="button" @click="_showList">{{'+'+getLanguageStr('word58','序列号')}}</button>
		</transition-group>
		<!-- <div class="mt2x" >
			<div class="tableSys mb05x vaM_E mb2x">
				<div class="w6x taR cSub pr1x">{{getLanguageStr('word58','序列号')}}</div>
				<div>
					<InputText v-model="sn" :maxLength="30" :clearBtn="true" name="sn"></InputText>
				</div>
				<div class="w7x pl1x vaT"><button class="functionBtn sizeM pl1x pr1x boxR" :class="{disable:sn ==''||sn.length<5|| proActive.active == -1}" @click="AddSN">{{$t('cmd10',['添加'])}}</button></div>
			</div>
		</div> -->
	</div>
	<WindowForAlert :title="getLanguageStr('word1779','添加新网关/采集器')" ref="intentSelectWindow" :size="'m'" class="windowWidth" :btnCancel="false">
    <div v-if="step==1">
      <div v-if="loggerList.length">
        <div class="mb1x">{{getLanguageStr('phrase721','添加设备的目的')}}</div>
        <div class="mb1x">
          <MyRadio
            class="dpIB mr2x "
            name="intent"
            v-model="addAction"
            label="add"
          >{{getLanguageStr("cmd170","新设备直接添加")}}</MyRadio>
          <MyRadio
            class="dpIB"
            name="intent"
            v-model="addAction"
            label="replace"
          >{{getLanguageStr("cmd169","替换电站内现有网关/采集器")}}</MyRadio>
        </div>
      </div>
      <div class="cSub pr1x mb05x">{{getLanguageStr('word58','序列号')}}:</div>
      <div class="mb05x">
        <InputText v-model="sn" :maxLength="30" :clearBtn="true" name="sn"></InputText>
      </div>
      <div class="cSub pr1x mb05x" v-if="addAction=='replace'">{{getLanguageStr('phrase710','选择替换对象')}}:</div>
      <div class="w70pct">
        <Select v-if="addAction=='replace'" class="mt05x w100pct" style="height:2.5em" :list="loggerList" :keyMap="{text:'nameSn',value:'deviceId'}" :bindActive="targetLogger"  @Click="targetIndex=>chooseTargetLogger(loggerList[targetIndex].type,loggerList[targetIndex].deviceId)"></Select>
      </div>
    </div>
    <div v-else>
      <div class="mb05x" v-show="!drop">{{$t('fill3rd144',[snUnit.sn,'你可以对网关/采集器xxxx进行如下操作'])}}</div>
      <div class="tableSys vaM_E" v-show="!drop">
          <div>
              <div class="mb05x"><span class="fs14x dpIB vaM">{{getLanguageStr('phrase772','当前子设备的添加方式')}} ： </span><span class="fs14x dpIB vaM">{{snUnit.autoDiscovery?getLanguageStr('word1982','自动添加子设备（推荐）'):getLanguageStr('word1620','手动添加子设备')}}</span><Help :code="'noSystem'" :btnClose="false" class="vaM ml1x"></Help></div>
              <div>{{getLanguageStr('phrase773','如果你的网关/采集器用于采集微逆设备且该网关/采集器用于多个电站，请点击这里手动选择子设备')}}</div>
          </div>
          <div class="w6x taR curP"><button :title="$t('fill3rd111',['','点击'])" type="button" :class="{transform:drop}" class="fR fa fa-angle-double-right hover-c-main fs16x mr05x cSub tra" @click="drop=!drop"></button></div>
      </div>
      <div v-show="drop">
        <div class="pb05x curP vaM_E" @click="drop=false"><Icon name="arrow-l" :sizeBase="'xxs'" class="w1x h1x" />&nbsp;<span>{{$t('cmd55',['返回'])}}</span></div>
        <div class="splitLine"></div>
         <AddDeveceList ref="AddDeveceList" :data="snUnit" @delChildDevice="delChildDevice" @devices="drop=false" :timezone="timezone" @hide="hide"></AddDeveceList>
      </div>
    </div>
    <button slot="btmBtn" class="functionBtn" @click="AddSN" v-if="!drop&&step==1" :class="{disable:!sn}">{{$t('cmd10',['添加'])}}</button>
    <button slot="btmBtn" class="functionBtn close" v-if="!drop&&step!=1" @click="sure">{{$t('cmd24',['完成'])}}</button>
	</WindowForAlert>
</div>
</template>
<script>
import * as lib from '@/util/lib.js'
import i18n from '@/util/language'
import {getLanguageStr} from '@/util/language.js'
import AddDeveceList from '@/components/common/AddDevice/AddDeviceLine.vue'
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue'
import Select from '@/components/common/ui/Select.vue'
import InputText from '@/components/common/ui/InputText.vue'
import TagBox from '@/components/common/ui/TagBox.vue'
import MyRadio from '@/components/common/ui/Radio'
import Help from '@/components/common/Help.vue'

import * as mainApi from '@/api/maintain/plant/list.js'

let timer
export default {
  name: 'AddConnectDevice',
  components: {WindowForAlert, Select, InputText, AddDeveceList, TagBox, MyRadio, Help},
  props: {
    type: {
      type: String,
      default: 'add'
    },
    timezone:{
      type:String,
      default:stage.time.timeZoneCode
    }
  },
  data () {
    return {
      stationId: '',
      systemId:'',
      sn: '',
      stage,
      deviceTypeActive: {
        active: -1,
        list: {}
      },
      brandActive: {
        active: -1,
        list: {}
      },
      proActive: {
        active: -1,
        list: {},
        device: {}
      },
      drop: false,
      DeviceList: [
        {text: getLanguageStr('word35', '逆变器'), value: 'INVERTER', api: 'OperationInverter'},
        {text: getLanguageStr('word39', '电表'), value: 'METER', api: 'OperationAmmeter'},
        {text: getLanguageStr('word647', '组件'), value: 'PV_MODULE', api: 'OperationComponet'},
        {text: getLanguageStr('word34', '采集器'), value: 'COLLECTOR', api: 'OperationCollector'},
        {text: getLanguageStr('word38', '气象站'), value: 'WEATHER_STATION', api: 'OperationWeather'}
      ],
      brandList: [
        {name: getLanguageStr('device232', '请选择品牌'), id: '-1',token:true}
      ],
      proList: [],
      // plantId:"",
      // deviceInfo:{},
      // // deviceType:"",
      sensorCode: '',
      // existingIds:[],
      addIntentCtrl: 'add', // 添加设备模式控制
      addAction: 'add', // add,replace;添加设备的目的
      loggerList: [], // 对应电站的采集器列表
      targetLogger: '', // 要替换的目标采集器sn
      snList: [],
      snUnit: {}, // sn添加后单元
      existed: false,
      step: 1,
      isRepeat:false,
      initType:''
      // count:{//统计添加设备的api执行数量
      // 	add:{max:0,now:0},
      // 	replace:{max:0,now:0}
      // }
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    transitionAction: lib.transitionAction,
    chooseTargetLogger(t,id){
    	this.initType=t
    	this.targetLogger=id
    },
    show (data) {
      this.snList = []
      this.reset()
      this.stationId = data.stationId
      this.systemId=data.systemId
      // this._getPro()
    },
    reset () {
      // this.deviceTypeActive.active=-1
      // this.brandActive.active=-1
      this.proActive.active = -1
      this.proActive.list = {}
      this.addAction = 'add'
      this.sn = ''
    },
    updateDeviceList () {

    },
    deviceSelect (index) {
      this.deviceTypeActive.active = this.DeviceList[index].value
      this.deviceTypeActive.list = this.DeviceList[index]
    },
    brandSelect (index) {
      this.brandActive.list = this.brandList[index]
      this.brandActive.active = this.brandList[index].id
      if (this.brandList[index].id != -1 && !this.brandList[index].code) {
        this.proList = [
          {name: getLanguageStr('device233', '请选择设备类型'), id: '-1',token:true}
        ]
        let request = {
          language:stage.languageId,
          brandId: this.brandActive.active
        }
        // 获取品牌下产品
        mainApi.AddBrandPro(request).then(res => {
          if (res) {
            this.proList = [...this.proList, ...res]
          } else {
            this.proList = [
              {name: getLanguageStr('device233', '请选择设备类型'), id: '-1',token:true}
            ]
          }
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
        })
      } else {
        this.sensorCode = this.brandActive.active = this.brandList[index].code
      }
    },
    ProSelect (index) {
      this.proActive.active = this.proList[index].id
      this.proActive.list = this.proList[index]
      if (this.proActive.active != -1) {
        let api = this.DeviceList.filter(el => { return el.value == this.proActive.list.deviceTypeName })
        this.proActive.device = api[0]
      }
    },
    // 添加序列号
    AddSN () {
    	if(this.addAction=='add'){
    		this.VertifyDevice()
    	}else{//替换网关
    		   var r = /^10[D|E|F].{9}$/;//dtu
         let b="COLLECTOR";
    	if(r.test(this.sn)){
		     b="DTU"
		}else{
			 b="COLLECTOR";
		}
		if(b==this.initType){
			this.VertifyDevice()
		}else{
			  this.$notify(getLanguageStr('error_code87', '被替换的网关类型和原网关类型不一致'))
		}
    	}
    },
  getLoggerList () {
      this.loggerList = []
      mainApi.GetGateway(this.stationId, {page: 1, size: 1000,systemId:this.systemId}).then((success) => {
    			success.forEach((val, index) => {
    				val.nameSn = val.name ? `${val.name}  ${val.sn}` : `${this.getTypeText(val.type, 'deviceType')}  ${val.sn}`
    			})
    			this.loggerList = success
    			if(this.loggerList.length>0){
    				this.targetLogger=this.loggerList[0].deviceId
    				this.initType=this.loggerList[0].type
    			}
    	}, (error) => {
    		!_.isEmpty(error) && this.$notify(error)
    	})
    },
    // 判断是否添加
    VertifyDevice () {
      this.existed = false
      let req = {
        stationId: this.stationId,
        sn: this.sn
      }
      mainApi.verifyDevice(req).then(res => {
        if (!res.existed && !res.autoDiscovery) {
          this.selectIntent(res.addedByOther)
          if(!this.isRepeat){
            if (this.addAction === 'add') {
              this.step = 2
            } else {          
            	//替换的状态
              this.snList.forEach(el=>{        //将替换的autoDiscovery赋予给snList
                if(el.replaceId==this.targetLogger){
                  el.autoDiscovery=this.loggerList.filter(el=>el.deviceId==this.targetLogger)[0].autoDiscovery
                }
              })
              this.$refs.intentSelectWindow.hide()
            }
          }
        } else {
          if (res.existed) {
            this.$notify(getLanguageStr('plant_detail195', '该设备已加入当前电站，不要重复添加'))
          } else if (!res.existed && res.autoDiscovery) {
            this.$notify(getLanguageStr('phrase665', '该设备已加入到别的电站，无法添加'))
          }
        }
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    selectIntent (addedByOther) { // 将添加的参数组成数组
      this.isRepeat=false
      let replaceId
      if (this.addAction == 'add') { // 直接添加设备
        replaceId = null
      } else {
        replaceId = this.targetLogger
      }
      let snCopy = _.cloneDeep(this.sn)
      let replaceIdCopy = _.cloneDeep(replaceId)
      if (this.snList.length && this.snList.filter(el => { return el.sn === snCopy }).length > 0) {
        this.$notify(i18n.t('phrase831', ['该设备已加入电站，无法添加']))
        this.isRepeat=true  //记录是否是重复状态
      } else {
        this.snUnit = {
          autoDiscovery: !addedByOther,
          defaultDiscovery: !addedByOther,
          modeChange: addedByOther,
          replaceId: replaceIdCopy,
          sn: snCopy,
          subDeviceIds: []
        }
        this.snList.push(_.cloneDeep(this.snUnit))
        this.isRepeat=false
      }

      // this.reset() // 添加至数组中，清除选项的值
    },
    // 获取产品
    _getPro () {
      this.proList = []
      let request = {
        language:stage.languageId,
        linkDevice: 1
      }
      mainApi.AddBrandPro(request).then(res => {
        let product = []
        if (res) {
          res.forEach((val, index) => {
            product[index] = {deviceTypeName: res[index].deviceTypeName, ...res[index].product}
          })
          this.proList = [{name: getLanguageStr('device234', '请选择产品'), id: '-1',token:true}, ...product]
        } else {
          this.proList = [
            {name: getLanguageStr('device234', '请选择产品'), id: '-1',token:true}
          ]
        }
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    // 获取品牌
    // _getBrand(){
    // 	this.brandList=[
    //         {name:getLanguageStr('device232','请选择品牌'),id:"-1",token:true},
    // 	]
    // 	let request={
    // 		language:stage.languageId
    // 	}
    // 	mainApi.AddBrand(request).then(res=>{
    // 		this.brandList=[...this.brandList,...res]
    // 	},error=>{
    // 		!_.isEmpty(error) && this.$notify(error)
    // 	})
    // },
    // 删除该新增的设备
    delChildDevice (index) {
      this.snList.splice(index, 1)
    },
    onRemove (sn, index) {
      this.snList.forEach((el, index) => {
        if (el.sn === sn) {
          this.snList.splice(index, 1)
        }
      })
    },
    _showList () {
      this.addAction='add'
      this.drop=false
      this.step = 1
      this.snUnit = {}
      this.sn = ''
      this.$refs.intentSelectWindow.show()
      lib.setScroll($(this.$el).find('[scroll]'))
      lib.fillHeight()
      this.getLoggerList()
    },
    clear () {
      this.snUnit={}
      this.snList=[]
    },
    sure(){
      this.snList.forEach((val,index)=>{
        if(val.sn==this.snUnit.sn){
          this.snList[index]=this.snUnit
        }
      })
    },
    hide(){
    	  this.$refs.intentSelectWindow.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
.window > .body .toolBar > *{
	padding-top: 0;
    font-size: inherit;
    margin-top: 0;
}
.enableList{padding:{bottom:.5em;};position:relative;
	.clearTag{position:absolute;top:0;right:.5em;}
}
.windowWidth /deep/ .body.body-m{
  width:60%
}
@media screen and (min-width:1500px){
  .windowWidth /deep/ .body.body-m{
   width:900px
  }
}
.transform{
    transform: rotate(-90deg);
}
</style>



// WEBPACK FOOTER //
// src/components/common/AddDevice/AddDevice.vue